import React, { Component } from "react";

import IntelliportSensorsParkinglocationsSelect from "./IntelliportSensorsParkinglocationsSelect";

import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Modal,
  Select,
  Divider,
  Switch,
  Icon,
} from "antd";

const FormItem = Form.Item;

class IntelliportSensorsSettingsForm extends Component {
  state = {
    modalVisible: false,
  };

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible,
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (values.coreParkingLocationId && values.placeID) {
          values.eventListener =
            "application/parking/" +
            values.coreParkingLocationId +
            "/place/" +
            values.placeID;
        }
        if (values.placeID) delete values.placeID;

        if (this.props.initialValues) {
          if (this.props.initialValues.parking_status == null) {
            values.parking_status = 3;
          } else {
            values.parking_status = this.props.initialValues.parking_status;
          }

          if (this.props.initialValues.last_message_id != null) {
            values.last_message_id = this.props.initialValues.last_message_id;
          }

          if (this.props.initialValues.last_communication != null) {
            values.last_communication =
              this.props.initialValues.last_communication;
          }
        }
        this.props.onSuccess(this.props.form, values);
      }
    });
  };

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    if (
      this.props.initialValues !== undefined &&
      this.props.initialValues !== null
    ) {
      this.props.initialValues.place_id = this.props.initialValues.place_id;
    }

    getFieldDecorator("last_parking_status_change", {
      initialValue:
        this.props.initialValues &&
        this.props.initialValues.last_parking_status_change
          ? this.props.initialValues.last_parking_status_change
          : new Date().toISOString(),
    });

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form
        onSubmit={this.handleSubmit}
        ref={(ref) => {
          this.form = ref;
        }}
      >
        <FormItem {...formItemLayout} label="PID">
          {getFieldDecorator("pid", {
            initialValue:
              this.props.initialValues && this.props.initialValues.pid
                ? this.props.initialValues.pid
                : null,
            rules: [
              {
                required: true,
                message: "Vyplňte prosím tuto položku!",
              },
            ],
          })(<Input />)}
        </FormItem>

        <FormItem {...formItemLayout} label="Sériové číslo">
          {getFieldDecorator("serial_number", {
            initialValue:
              this.props.initialValues && this.props.initialValues.serial_number
                ? this.props.initialValues.serial_number
                : null,
            rules: [
              {
                required: true,
                message: "Vyplňte prosím tuto položku!",
              },
            ],
          })(<Input />)}
        </FormItem>

        <FormItem {...formItemLayout} label="Lokalita">
          {getFieldDecorator("carpark_id", {
            initialValue:
              this.props.initialValues && this.props.initialValues.carpark_id
                ? this.props.initialValues.carpark_id
                : undefined,
            rules: [
              {
                required: true,
                message: "Vyplňte prosím tuto položku!",
              },
            ],
          })(
            <IntelliportSensorsParkinglocationsSelect
              onChange={(value) => {
                this.props.form.setFieldsValue({ carpark_id: value });
              }}
            />
          )}
        </FormItem>

        <FormItem {...formItemLayout} label="Místo">
          {getFieldDecorator("place_id", {
            initialValue:
              this.props.initialValues && this.props.initialValues.place_id
                ? this.props.initialValues.place_id
                : null,
            rules: [
              {
                required: true,
                message: "Vyplňte prosím tuto položku!",
              },
            ],
          })(<InputNumber />)}
        </FormItem>

        <FormItem {...formItemLayout} label="Upozornění">
          {getFieldDecorator("reports_enabled", {
            valuePropName: "checked",
            initialValue:
              this.props.initialValues &&
              this.props.initialValues.reports_enabled
                ? this.props.initialValues.reports_enabled
                : false,
          })(<Switch />)}
        </FormItem>

        <FormItem {...tailFormItemLayout}>
          {this.props.initialValues ? (
            <Button type="primary" htmlType="submit">
              Uložit
            </Button>
          ) : (
            <Button type="primary" htmlType="submit">
              Vložit
            </Button>
          )}
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === "modal") {
      return (
        <Modal
          width={700}
          title={
            this.props.initialValues
              ? "Nastavení senzoru"
              : "Vložení nového senzoru"
          }
          visible={this.state.modalVisible}
          maskClosable={false}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          okText={this.props.initialValues ? "Uložit" : "Vložit"}
        >
          {this.renderForm()}
        </Modal>
      );
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(
  IntelliportSensorsSettingsForm
);

export default WrappedParkinglocationForm;



// WEBPACK FOOTER //
// ./src/components/IntelliportSensorsSettingsForm.js